import type { FormConfig } from '@acme/foundation';

export type CounterpartyOfferFormData = {
  commissionAuthorizedOrganizationRUB: number | '';
  files: File[];
};

const requiredAlways = {
  when: () => true,
  set: { required: true },
} as const;

export const counterpartyOfferFormConfig =
  (): FormConfig<CounterpartyOfferFormData> => ({
    id: 'counterparty-offer-form',
    includeUnchangedFields: false,
    controls: [
      {
        id: 'commissionAuthorizedOrganizationRUB',
        label: 'Комиссия уполномоченной организации, руб',
        type: 'number',
        read: (ctx) =>
          ctx?.commissionAuthorizedOrganizationRUB !== undefined &&
          ctx?.commissionAuthorizedOrganizationRUB !== null
            ? ctx.commissionAuthorizedOrganizationRUB
            : '',
        write: { path: 'commissionAuthorizedOrganizationRUB' },
        validation: (v) => {
          const n = typeof v === 'number' ? v : Number(v);
          if (!Number.isFinite(n) || n <= 0)
            return 'Укажите комиссию (положительное число)';
          return null;
        },
        props: { placeholder: '' },
        rules: [requiredAlways],
      },
      {
        id: 'files',
        label: 'Загрузка документов',
        type: 'fileUpload',
        read: () => [],
        write: {
          path: 'files',
          transform: (v: unknown) =>
            Array.isArray(v) ? (v as { file: File }[]).map((u) => u.file) : [],
        },
        props: {
          label: 'Загрузка документов',
          accept: '.pdf',
          maxSize: 10,
          multiple: true,
          showInfoIcon: true,
        },
      },
    ],
  });
